import style from "./greeting.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import animations from '@styles/animations.module.scss';
import { InView } from 'react-intersection-observer';
import { IGreetingSection } from "../givingli.content";


type GreetingProps = {
  greeting: IGreetingSection;
}

const Greeting = ({greeting}: GreetingProps) => {

    return (
        <SharedAnimation render={() => (
          <section className={`${style.section}`}>
            <div className={`${style.container}`}>
              <div className={style.section__title}>
                {greeting.title}
              </div>
      
              {greeting.cards.map((card, index) => (
                <InView triggerOnce={true} key={index}>
                  {({ inView, ref, entry }) => {
                    if (inView) {
                      entry?.target.classList.add(animations.active);
                    }
                    return (
                      <div
                        ref={ref}
                        className={`${style.card__item} ${animations.scroll__animation}`}
                      >
                        <div className={`${style.card__item__info}`}>
                          <div className={style.card__item__title}>
                            {card.title}
                          </div>
                          <div className={style.card__item__text}>
                              {card.text}
                          </div>
                        </div>
                        <div className={`${style.card__item__image}`}>
                          <Image
                            alt="mockup-givingli"
                            src={card.image}
                            loading="eager"
                            layout="fill"
                          />
                        </div>
                      </div>
                    );
                  }}
                </InView>
              ))}
            </div>
          </section>
        )} />
      );
}

export default Greeting;